const urlParams = new URLSearchParams(window.location.search);

export const isFromApp = urlParams.get('appview') != null;
